import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListSelectComponent } from '../../../../shared/components/table-list-select/table-list-select.component'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { SearchVehicleTypeModel } from '../../../../core/models/vehicle-type.model'
import { ResponseRequestModel } from '../../../../core/models/response.model'

@Component({
  selector: 'supplier-vehicle-type',
  imports: [
    FormsModule,
    MatButton,
    MatFormFieldModule,
    MatIcon,
    MatInput,
    MatProgressBar,
    PaginationComponent,
    TableListSelectComponent,
  ],
  templateUrl: './supplier-vehicle-type.component.html',
  styleUrl: './supplier-vehicle-type.component.scss',
  providers: [VehicleTypeService],
  standalone: true,
})
export class SupplierVehicleTypeComponent implements OnInit {
  constructor(private vehicleTypeService: VehicleTypeService) {}

  @Input() listSelected: any[] = []
  @Output() response = new EventEmitter<any[]>()

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  inputSearch = ''

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Tipo veículo',
    },
    {
      keyColumn: 'capacidade',
      key: 'capacidade',
      description: 'Capacidade',
    },
  ]

  ngOnInit(): void {
    this.getListItems()
  }

  getListItems() {
    this.loading = true
    const request = this.inputSearch.trim()
      ? this.vehicleTypeService.searchPagedVehicleType(
          this.page,
          this.rows,
          this.searchModel(),
        )
      : this.vehicleTypeService.listPagedVehicleType(this.page, this.rows)

    request.subscribe({
      next: (response: ResponseRequestModel) => {
        this.treatResponse(response)
      },
      error: () => {
        this.itemsList = []
        this.numberRows = 0
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchModel(): SearchVehicleTypeModel {
    const model = new SearchVehicleTypeModel()
    model.descricao = this.inputSearch.trim()
    return model
  }

  // Quando não há registros a API responde 206 com data nula.
  treatResponse(response: ResponseRequestModel) {
    this.itemsList = response.data ?? []
    this.numberRows = response.totalItens ?? 0
  }

  search() {
    this.page = 1
    this.getListItems()
  }

  clearSearch() {
    this.inputSearch = ''
    this.page = 1
    this.getListItems()
  }

  pageChanged(page: number) {
    this.page = page
    this.getListItems()
  }

  selectItem(item: any) {
    const index = this.listSelected.findIndex((ele: any) => ele.id == item.id)
    if (index > -1) {
      this.listSelected.splice(index, 1)
    } else {
      this.listSelected.push(item)
    }
    this.response.emit(this.listSelected)
  }

  removeItem(item: any) {
    const index = this.listSelected.findIndex((ele: any) => ele.id == item.id)
    if (index > -1) {
      this.listSelected.splice(index, 1)
      this.response.emit(this.listSelected)
    }
  }
}
